export default __webpack_public_path__ + "9b705d681ea8409de76e645ae3f00a44.png";